<template>
  <div class="z-card">
    <z-form-group class="row form-group form-group--modal">
      <z-form-input class="col-12" :rules="{ required: true }">
        <v-text-field
          :label="$t('tasks.campaign.form.name')"
          v-model="form.customer_name"
          outlined
          dense
        />
      </z-form-input>
    </z-form-group>
    <z-form-group class="row form-group--modal align-items-baseline">
      <z-form-input class="col-12" :rules="{ phone: true, required: true }">
        <tel-input v-model="form.customer_phone" class="mt-1" />
      </z-form-input>
    </z-form-group>
    <z-form-group class="row form-group--modal align-items-baseline">
      <z-form-input class="col-12">
        <v-text-field
          :label="$t('tasks.campaign.form.country')"
          v-model="form.customer_country"
          outlined
          dense
        />
      </z-form-input>
    </z-form-group>
    <z-form-group class="row form-group--modal align-items-baseline">
      <z-form-input class="col-12">
        <v-text-field
          :label="$t('tasks.campaign.form.region')"
          v-model="form.customer_region"
          outlined
          dense
        />
      </z-form-input>
    </z-form-group>
    <z-form-group class="row form-group--modal align-items-baseline">
      <z-form-input class="col-12">
        <v-text-field
          :label="$t('tasks.campaign.form.city')"
          v-model="form.customer_city"
          outlined
          dense
        />
      </z-form-input>
    </z-form-group>
    <z-form-group class="row form-group--modal align-items-baseline">
      <z-form-input class="col-12">
        <v-text-field
          :label="$t('tasks.campaign.form.address')"
          v-model="form.customer_address"
          outlined
          dense
        />
      </z-form-input>
    </z-form-group>
    <z-form-group class="row form-group--modal align-items-baseline">
      <z-form-input class="col-12">
        <v-text-field
          :label="$t('tasks.campaign.form.index')"
          v-model="form.customer_zip"
          outlined
          dense
        />
      </z-form-input>
    </z-form-group>
    <z-form-group class="row form-group--modal align-items-baseline">
      <z-form-input class="col-12" :rules="{ email: true }">
        <v-text-field
          :label="$t('tasks.campaign.form.email')"
          v-model="form.customer_email"
          outlined
          dense
        />
      </z-form-input>
    </z-form-group>
    <z-form-group class="row form-group--modal align-items-baseline">
      <z-form-input class="col-12">
        <v-textarea
          :label="$t('tasks.campaign.form.comments')"
          v-model="form.comments"
          outlined
          dense
        />
      </z-form-input>
    </z-form-group>
  </div>
</template>

<script>
  import TelInput from '@shared/components/input/input-phone-number';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import pick from 'lodash-es/pick';

  export default {
    components: {
      TelInput
    },
    props: {
      is_edit: {
        type: Boolean,
        default: false
      },
      allow_call: {
        type: Boolean,
        default: false
      },
      current_task: {
        type: Object,
        default: () => ({})
      }
    },
    data: () => ({
      form: {
        customer_name: '',
        customer_phone: '',
        customer_country: '',
        customer_region: '',
        customer_city: '',
        customer_address: '',
        customer_zip: '',
        customer_email: '',
        comments: ''
      }
    }),

    computed: {
      phone_format() {
        return `${this.form.customer_phone}`;
      }
    },

    watch: {
      current_task: {
        handler: function (val) {
          this.form = defaultsDeep(
            pick(val, [
              'customer_name',
              'customer_phone',
              'customer_country',
              'customer_region',
              'customer_city',
              'customer_address',
              'customer_zip',
              'customer_email',
              'comments'
            ]),
            {
              customer_name: '',
              customer_phone: '',
              customer_country: '',
              customer_region: '',
              customer_city: '',
              customer_address: '',
              customer_zip: '',
              customer_email: '',
              comments: ''
            }
          );
          this.form.customer_phone = this.form.customer_phone
            ? '+' + this.form.customer_phone
            : this.form.customer_phone;
        },
        immediate: true,
        deep: true
      }
    },

    methods: {
      returnInfo() {
        this.$emit('base_form', this.form);
      }
    }
  };
</script>
